export default __webpack_public_path__ + "5b55027cc3603cc7134f1d3275186b63.png";